import React from "react";
import TextButton from "../../../templates/component/buttons/textButton";

const ImageGalleryAddButton = () =>{

    return(
        <>
            <TextButton />

        </>
    )
}

export default ImageGalleryAddButton;